import * as angular from "angular";

const inActiveTaskStatuses = ['Canceled', 'CourierDeparted', 'ManualHandled']
const completedTaskStatuses = ['CourierDeparted', 'ManualHandled'];

angular
  .module('bringoz.admin.itineraries')
  .constant('itinerariesConstant', {
    inActiveTaskStatuses: inActiveTaskStatuses,
    completedTaskStatuses: completedTaskStatuses
  });
